'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  width: 100%;\n  height: 50px;\n  position: relative;\n  border-bottom: 1px solid ', ';\n'], ['\n  width: 100%;\n  height: 50px;\n  position: relative;\n  border-bottom: 1px solid ', ';\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  color: ', ';\n  font-size: 20px !important;\n  display: block;\n  pointer-events: none;\n  position: absolute;\n  left: 30px;\n  top: 50%;\n  transform: translateY(-50%);\n'], ['\n  color: ', ';\n  font-size: 20px !important;\n  display: block;\n  pointer-events: none;\n  position: absolute;\n  left: 30px;\n  top: 50%;\n  transform: translateY(-50%);\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  width: 100%;\n  height: 100%;\n  display: block;\n  border: none;\n  background: none;\n  color: ', ';\n  font-family: inherit;\n  padding: 0px;\n  padding-left: 80px;\n  margin: 0px;\n  font-size: 16px;\n  font-weight: 300;\n\n  &:focus {\n    outline: none;\n  }\n'], ['\n  width: 100%;\n  height: 100%;\n  display: block;\n  border: none;\n  background: none;\n  color: ', ';\n  font-family: inherit;\n  padding: 0px;\n  padding-left: 80px;\n  margin: 0px;\n  font-size: 16px;\n  font-weight: 300;\n\n  &:focus {\n    outline: none;\n  }\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _colors = require('../../../libs/colors');

var _Icon = require('../../Icon/Icon');

var _Icon2 = _interopRequireDefault(_Icon);

var _InputTyping = require('../../InputTyping/InputTyping');

var _InputTyping2 = _interopRequireDefault(_InputTyping);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
} // Colors
// Components


var Container = _styledComponents2.default.div(_templateObject, _colors.grey);

var SearchIcon = (0, _styledComponents2.default)(_Icon2.default)(_templateObject2, _colors.darkGrey);

var Input = _styledComponents2.default.input(_templateObject3, _colors.black);

var SearchInput = function SearchInput(_ref) {
  var value = _ref.value,
      onChange = _ref.onChange;
  return _react2.default.createElement(Container, null, _react2.default.createElement(_InputTyping2.default, {
    Component: Input,
    value: value,
    onChange: onChange
  }), _react2.default.createElement(SearchIcon, {
    icon: 'search1'
  }));
};

SearchInput.propTypes = {
  value: _propTypes2.default.string,
  onChange: _propTypes2.default.func
};
exports.default = SearchInput;